export default __webpack_public_path__ + "static/media/gshar-video.b41ffbc9.jpg";